import { render } from "./product-bundle-select.vue?vue&type=template&id=15b22803"
import script from "./product-bundle-select.vue?vue&type=script&lang=js"
export * from "./product-bundle-select.vue?vue&type=script&lang=js"

import "./product-bundle-select.vue?vue&type=style&index=0&id=15b22803&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__